import { useShop } from "context/shop-context";

function Logo({ className }: { className: string }) {
  const { name, logo } = useShop();

  return <img alt={name} className={className} src={logo} />;
}

export default Logo;
